<template>
  <nav class="inline-flex items-center text-sm" data-testid="breadcrumbs">
    <ol class="group flex w-auto leading-none md:flex-wrap">
      <li
        v-for="(item, index) in breadcrumbs"
        :key="item.name"
        class="flex cursor-pointer items-center text-neutral-500 last-of-type:font-semibold last-of-type:text-neutral-900"
      >
        <ZenniIconsIconChevronRight v-if="index > 0" class="text-neutral-500" />
        <a
          v-if="index < breadcrumbs.length - 1"
          :href="item.link"
          variant="secondary"
          class="outline-secondary-600 whitespace-nowrap leading-5 text-inherit no-underline hover:underline active:underline"
        >
          {{ item.name }}
        </a>
        <span v-else class="capitalize">
          {{ item.name }}
        </span>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import { toRefs } from 'vue'

const props = defineProps({
  breadcrumbs: {
    type: Array<{ name: string; link: string }>,
    default: [],
  },
})
const { breadcrumbs } = toRefs(props)
</script>
